import {
  DialogTitle,
  Typography,
  DialogContent,
  Dialog,
  Button,
  CircularProgress,
} from '@material-ui/core'
import React, { useState } from 'react'

interface ConfirmFixDuplicatesModalProps {
  open: boolean
  onClose: () => void
  handleFixDuplicateProducts: () => Promise<void>
  onRetryPrevalidate?: () => void
}

export const ConfirmFixDuplicatesModal: React.FC<ConfirmFixDuplicatesModalProps> = ({
  open,
  onClose,
  handleFixDuplicateProducts,
  onRetryPrevalidate,
}) => {
  const [isFixing, setIsFixing] = useState(false)

  const fixDuplicates = async () => {
    setIsFixing(true)
    try {
      await handleFixDuplicateProducts()
      onClose()
      if (onRetryPrevalidate) {
        onRetryPrevalidate()
      }
    } catch (error) {
      console.error('Error fixing duplicate products:', error)
    } finally {
      setIsFixing(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography component="h2" style={{ fontSize: '1.25rem', fontWeight: 600 }}>
            Are you sure you want to Automatically Fix Duplicate Product Names?
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={onClose}
          disabled={isFixing}
          style={{ minWidth: 80, marginRight: 8 }}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={fixDuplicates}
          disabled={isFixing}
          style={{ minWidth: 80 }}
        >
          {isFixing ? 'Fixing...' : 'Fix Automatically'}
        </Button>
      </DialogContent>
    </Dialog>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/ConfirmFixDuplicatesModal.tsx